import {Navigate} from 'react-router-dom';
import {useSelector} from "react-redux";
import {CONSTANTS} from "../constants/constants";

export const withAuth = (WrappedComponent) => (props) => {
  const isAuth = useSelector(state => state.user.isAuth);

  return isAuth ? <WrappedComponent {...props} /> : <Navigate to={CONSTANTS.ROUTES.AUTH.path}/>;
};